import { isSequenceApiError, isSequenceApiErrorResponse } from '@sequencehq/api'

export const getContactEmailError = (
  error: unknown
): { hasError: boolean; message: string } => {
  if (
    !isSequenceApiError(error) ||
    !isSequenceApiErrorResponse(error.response)
  ) {
    return { hasError: false, message: '' }
  }

  const emailError = error.response?.error.errors.find(
    ({ key }) => key === 'email'
  )

  if (!emailError) {
    return { hasError: false, message: '' }
  }

  return {
    hasError: true,
    message: emailError.message
  }
}
